// Exact money arithmetic for the client — mirrors backend/src/utils/validate.js
// so the total shown on screen is the total the server stores. qty × price is
// done in integer cents (BigInt), rounded half-up: 1.5 × 2.35 = 3.53, not the
// float 3.5250000000000004 → 3.52.

const scaled = (n, scale) => {
  const [int, frac = ''] = Number(n).toFixed(scale).split('.');
  const neg = int.startsWith('-');
  const digits = BigInt((neg ? int.slice(1) : int) + frac.padEnd(scale, '0').slice(0, scale));
  return neg ? -digits : digits;
};

// Line total in cents (BigInt). Invalid/blank inputs count as 0.
export function lineTotalCents(qty, unitPrice) {
  const q = Number(qty), p = Number(unitPrice);
  if (!Number.isFinite(q) || !Number.isFinite(p)) return BigInt(0);
  return (scaled(q, 3) * scaled(p, 2) + BigInt(500)) / BigInt(1000);
}

export const toCents = (n) => (Number.isFinite(Number(n)) ? scaled(Number(n), 2) : BigInt(0));

export function centsToString(c) {
  const neg = c < BigInt(0);
  const s = (neg ? -c : c).toString().padStart(3, '0');
  return `${neg ? '-' : ''}${s.slice(0, -2)}.${s.slice(-2)}`;
}

// Convenience: exact line total as a 2-dp string, e.g. "3.53".
export const lineTotal = (qty, unitPrice) => centsToString(lineTotalCents(qty, unitPrice));
